import React from 'react';
import Panel from '../panel/Panel';
import './Layout.scss';
import MobileMenu from '../mobile-menu/MobileMenu';
import FirstProjectOnboarding from '../onboarding-popup/FirstProjectOnboarding';
import VideoTutorial from '../onboarding-video/VideoTutorial';
import TrialBar from '../../trial-bar/TrialBar';
import ImpersonationBanner from '../../impersonation-banner/ImpersonationBanner';
import VersionBanner from '../../version-banner/VersionBanner';
import useBilling from '../../../hooks/account/UseBilling';
import { useAccount } from '../../../contexts/account/AccountContexts';

interface LayoutProps {
  children: React.ReactNode;
  dataPage?: 'faq' | 'trial-ended' | 'integrations' | 'geo-audit' | '';
}

const Layout: React.FC<LayoutProps> = ({ children, dataPage = '' }) => {
  const { accountResponse } = useAccount();
  const canShowBilling = useBilling();

  const isGradientPage =
    dataPage === 'faq' ||
    dataPage === 'trial-ended' ||
    dataPage === 'integrations' ||
    dataPage === 'geo-audit';

  return (
    <div className="layout">
      <FirstProjectOnboarding />
      <VideoTutorial />
      <ImpersonationBanner />
      <VersionBanner />
      <div className="layout__page">
        <div className="layout__left">
          <Panel />
        </div>
        <div
          className={`layout__right ${isGradientPage && 'layout__right--gradient'}`}
          data-page={dataPage}
        >
          <TrialBar position="top" />
          <div
            className={`layout__mobile ${
              !accountResponse ||
              accountResponse.accountStatus === 'PAID' ||
              !canShowBilling ||
              (accountResponse.accountStatus === 'TRIAL' && !accountResponse?.showTrialNotification)
                ? ''
                : 'layout__mobile--bar'
            }`}
          >
            <MobileMenu />
          </div>
          <main>{children}</main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
